import { DocumentFormValues, DocumentTypeEnumType } from 'features/declaration/models/schemas/documentSchemas'
import { FileType } from 'features/declaration/models/schemas/fileSchemas'
import { hasText } from 'shared/lib/common-util'
import { DocumentSave } from './request'

type DocumentSubType = {
  sequenceNumber: number
  type: DocumentTypeEnumType
}

// eslint-disable-next-line import/prefer-default-export
export function isDocumentEqual(document: DocumentSubType, other: DocumentSubType) {
  return document.sequenceNumber === other.sequenceNumber && document.type === other.type
}

function isReadyForUpload(file: FileType) {
  return file.id == null && !file.deleted && file.fileBlob && file.documentId != null && !hasText(file.uuid)
}

export function collectSavedDocumentFilesToBeUploaded(savedDocuments: DocumentFormValues[], allDocuments: DocumentSave[]) {
  const files: FileType[] = []
  for (const savedDocument of savedDocuments) {
    if (savedDocument.id == null) {
      continue
    }

    for (const document of allDocuments) {
      if (isDocumentEqual(savedDocument, document)) {
        const documentFiles = document.files
        for (const f of documentFiles) {
          f.documentId = savedDocument.id
        }
        files.push(...documentFiles.filter(isReadyForUpload))
      }
    }
  }

  return files
}

export function collectDeletableDocumentFiles(documents: DocumentSave[]) {
  return documents
    .flatMap((d) => d.files)
    .filter((f) => f.deleted && hasText(f.uuid))
}
